<template>
    <div id="page-branch-list">
        <div class="vx-card p-6">
            <div class="vx-row">
                <div class="vx-col xl:w-1/4 lg:w-1/3 md:w-1/2 w-full">
                    <label class="vs-input--label">{{ $t('tasks.project') }}</label>
                    <v-select class="" v-model="selectedProjectId" :options="projectData" :clearable="false"
                              :reduce="(options) => options.value" @input="getEmployee" :disabled="!!projectId">
                    </v-select>
                </div>
                <div class="vx-col xl:w-1/4 lg:w-1/3 md:w-1/2 w-full">
                    <label class="vs-input--label">{{ $t('tasks.assignedPerson') }}</label>
                    <v-select class="" v-model="selecEmployee" :options="employeeOption" :clearable="false"
                              :reduce="(options) => options.value">
                    </v-select>
                </div>
                <div class="vx-col xl:w-1/4 lg:w-1/3 md:w-1/2 w-full">
                    <label class="vs-input--label">{{ $t('tasks.startTimeAndEndTime') }}</label>
                    <date-range-picker ref="picker" class="w-full" :locale-data="{ format: 'dd/mm/yyyy' }"
                                       :opens="'left'" @update="dateRangePicker" v-model="dateRange">
                    </date-range-picker>
                </div>
                <div class="vx-col xl:w-1/4 lg:w-1/3 md:w-1/2 w-full">
                    <label class="vs-input--label">{{ $t('tasks.title') }}</label>
                    <vs-input class="w-full" v-model="taskTitle" placeholder="Tìm kiếm theo tiêu đề ..."></vs-input>
                </div>
                <div class="vx-col xl:w-full lg:w-2/3 w-full mt-6 flex gap-3">
                    <vs-button color="primary" type="border" icon-pack="feather" icon="icon-plus" @click="addNewTask">
                        {{ $t('tasks.addNewTask') }}
                    </vs-button>
                    <vs-button color="primary" icon-pack="feather" icon="icon-search" @click="getTask">{{
                            $t('tasks.search')
                        }}
                    </vs-button>
                </div>
            </div>
        </div>

        <div class="mt-4 gap-10 area-task-kanban p-4">
            <div class="flex gap-10 kanban-view" :class="kanbanData.length > 4 ? '' : 'kanban-view-more'">
                <div v-for="(column, index) in kanbanData" :key="index" class="mt-10 mb-4">
                    <div class="header-column" id="title-size" :title="column.status"
                         :style="{borderBottom: `3px solid ${column.color}`}">
                        <span class="font-semibold text-sm">{{ column.title }}</span>
                        <span class="font-semibold text-sm float-right">({{ column.taskResponseDTOS.length }})</span>
                    </div>
                    <VuePerfectScrollbar ref="mainSidebarPs" class="scroll-area-task p-0 mt-6" :settings="settings"
                                         :key="$vs.rtl">
                        <draggable :list="column.taskResponseDTOS" ghost-class="ghost-card" group="taskResponseDTOS"
                                   @change="updateTask($event, column.status)" class="size-draggable">
                            <TaskCard v-for="(task, ind) in column.taskResponseDTOS" :key="ind" :task="task"
                                      :taskLabel="taskLabelptions" :priorityOptions="priorityOptions"
                                      class="task--drag" id="screen-size">
                            </TaskCard>
                        </draggable>
                    </VuePerfectScrollbar>
                </div>
            </div>
        </div>

        <vs-popup :title="$t('tasks.addTask')" :active.sync="popupActiveUse" id="popup-create-task">
            <div class="vx-col md:w-full">
                <label class="vs-input--label required">{{ $t('tasks.project') }}</label><br/>
                <v-select v-model="selecProjecDataPopup" :clearable="false" v-validate="'required'" name="pr"
                          :options="projectDataPopup" :reduce="(options) => options.value" @input="getEmployee"
                          :disabled="!!projectId">
                </v-select>
                <span class="text-danger text-sm">{{ errors.first('pr') }}</span>
            </div>
            <div class="vx-row">
                <div class="vx-col w-full mt-4">
                    <label class="vs-input--label required">{{ $t('tasks.title') }}</label><br/>
                    <vs-input v-model="taskData.title" class="w-full" v-validate="'required'" name="title"/>
                    <span class="text-danger text-sm">{{ errors.first('title') }}</span>
                </div>
                <div class="vx-col w-full mt-4">
                    <label class="vs-input--label required">{{ $t('tasks.description') }}</label><br/>
                    <vs-textarea class="w-full" v-model="taskData.description" v-validate="'required'"
                                 name="description"></vs-textarea>
                    <span class="text-danger text-sm">{{ errors.first('description') }}</span>
                </div>
                <div class="vx-col w-full mt-4">
                    <label class="vs-input--label required">{{ $t('tasks.status') }}</label><br/>
                    <v-select class="w-full" v-model="taskData.selectedStatus" :clearable="false"
                              v-validate="'required'" name="stt" :options="statusOptions"
                              :reduce="(options) => options.value">
                    </v-select>
                    <span class="text-danger text-sm">{{ errors.first('stt') }}</span>
                </div>
                <div class="vx-col w-full mt-4">
                    <label class="vs-input--label">{{ $t('tasks.jobLabel') }}</label><br/>
                    <v-select class="w-full" v-model="selectedTaskLabel" :clearable="false"
                              :options="taskLabelptions" multiple @input="changeSelectTaskLabel">
                    </v-select>
                </div>
                <div class="flex vx-col w-full">
                    <div class="vx-col md:w-1/2 w-1/2 mt-4">
                        <label class="vs-input--label required">{{ $t('tasks.startDate') }}</label>
                        <div class="w-full">
                            <datepicker class="w-full" :language="vi" :format="'dd/MM/yyyy'" :highlighted="highlighted"
                                        v-model="selectstartDate" data-vv-validate-on="input" ref="datepickBooking"
                                        v-validate="'required'" name="timeStart">
                            </datepicker>
                            <span class="text-danger text-sm">{{ errors.first('timeStart') }}</span>
                        </div>
                    </div>
                    <div class="vx-col md:w-1/2 w-1/2 mt-4 ml-2">
                        <label class="vs-input--label required">{{ $t('tasks.hours') }}</label>
                        <div class="w-full">
                            <flat-pickr :config="configTimePicker" v-model="selectStartTime"
                                        class="w-full vs-inputx vs-input--input normal" v-validate="'required'"
                                        name="hourStart"/>
                        </div>
                        <span class="text-danger text-sm">{{ errors.first('hourStart') }}</span>
                    </div>
                </div>
                <div class="flex vx-col w-full">
                    <div class="vx-col md:w-1/2 w-1/2 mt-4">
                        <label class="vs-input--label required">{{ $t('tasks.deadline') }}</label>
                        <div class="w-full">
                            <datepicker class="w-full" :language="vi" :format="'dd/MM/yyyy'" :highlighted="highlighted"
                                        v-model="selectEndDate" data-vv-validate-on="input" ref="datepickBooking"
                                        v-validate="'required'" name="timeEnd">
                            </datepicker>
                            <span class="text-danger text-sm">{{ errors.first('timeEnd') }}</span>
                        </div>
                    </div>
                    <div class="vx-col md:w-1/2 w-1/2 mt-4 ml-2">
                        <label class="vs-input--label required">{{ $t('tasks.hours') }}</label>
                        <div class="w-full">
                            <flat-pickr :config="configTimePicker" v-model="selectEndTime"
                                        class="w-full vs-inputx vs-input--input normal" v-validate="'required'"
                                        name="hourEnd"/>
                        </div>
                        <span class="text-danger text-sm">{{ errors.first('hourEnd') }}</span>
                    </div>
                </div>
                <div class="vx-col w-full mt-4">
                    <label class="vs-input--label required">{{ $t('tasks.assignedPerson') }}</label><br/>
                    <v-select v-model="taskData.selectedEmployeeOption" :clearable="false" name="people"
                              :options="employeeOptionPopup" :reduce="(options) => options.value"
                              v-validate="'required'" @input="changSelecEmployee">
                    </v-select>
                    <span class="text-danger text-sm">{{ errors.first('people') }}</span>
                </div>
                <div class="vx-col w-full mt-4">
                    <label class="vs-input--label required">{{ $t('tasks.priority') }}</label><br/>
                    <v-select :clearable="false" v-model="taskData.selectedPriority" name="level"
                              :options="priorityOptions" :reduce="(options) => options.value" v-validate="'required'">
                    </v-select>
                    <span class="text-danger text-sm">{{ errors.first('level') }}</span>
                </div>
                <div class="vx-col w-full mt-4">
                    <label class="vs-input--label">{{ $t('tasks.listOfAddedPeople') }}</label><br/>
                    <v-select class="w-full" v-model="selectedCollaborators" :clearable="false"
                              :options="collaboratorsOption" multiple @input="changeSelectMultiple">
                    </v-select>
                </div>
            </div>
            <div class="vx-row mt-4">
                <div class="vx-col w-full mt-2.5">
                    <div class="mt-2 flex flex-wrap items-center justify-end mb-2">
                        <vs-button class="mr-5" @click="saveTask">{{ $t('tasks.save') }}
                        </vs-button>
                        <vs-button class="" color="danger" type="border" @click="popupActiveUse = false">{{
                                $t('tasks.close')
                            }}
                        </vs-button>
                    </div>
                </div>
            </div>
        </vs-popup>
    </div>
</template>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<script>
import {AgGridVue} from "ag-grid-vue"
import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss'
import DateRangePicker from '../../../components/vue2-daterange-picker/components/DateRangePicker.vue'
import vSelect from 'vue-select'
import TaskCard from "./Task.vue"
import draggable from "vuedraggable"
import moment from "moment"
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import Multiselect from 'vue-multiselect'
import Datepicker from 'vuejs-datepicker'
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
import {vi} from 'vuejs-datepicker/dist/locale'
import {isAPI} from "../../../store/permission"
import {constAPI} from "../../../store/constant"
// import 'quill/dist/quill.snow.css'
// import {quillEditor} from 'vue-quill-editor'

export default {
    components: {
        AgGridVue,
        DateRangePicker,
        vSelect,
        TaskCard,
        draggable,
        Multiselect,
        VuePerfectScrollbar,
        Datepicker,
        flatPickr,
        // quillEditor,
    },
    data() {
        return {
            drag: true,
            kanbanData: [],
            vi: vi,
            popupActiveUse: false,
            popupChange: false,
            settings: {
                maxScrollbarLength: 60,
                wheelSpeed: .60,
            },
            projectId: null,
            taskList: {},
            projectDataTable: [],
            taskOptions: [],
            organizationBranchOptions: [],
            selectedOrganizationBranch: null,
            employeeOption: [{value: 0, label: 'Tất cả'}],
            selecEmployee: 0,
            employeeOptionPopup: [],
            collaboratorsOption: [],
            selectedCollaborators: [],
            configTimePicker: {
                enableTime: true,
                noCalendar: true,
                dateFormat: "H:i",
                time_24hr: true,
                minTime: "07:00",
            },
            dateRange: {
                endDate: new Date(new Date().setDate(new Date().getDate() - new Date().getDay() + 5)),
                startDate: new Date(new Date().setDate(new Date().getDate() - new Date().getDay() + 1))
            },
            highlighted: {
                dates: [
                    new Date()
                ]
            },
            taskData: {},
            startDateAddRange: {
                startDate: new Date(),
                endDate: new Date(),
            },
            getTaskData: [],
            projectData: [],
            selectedProjectId: 'null',
            projectDataPopup: [],
            selecProjecDataPopup: null,
            statusOptions: [],
            priorityOptions: [],
            dragData: [],
            statusAddId: null,
            statusRemoveId: null,
            selectstartDate: null,
            selectStartTime: null,
            selectEndDate: null,
            selectEndTime: null,
            userInfo: JSON.parse(localStorage.getItem('userInfo')),
            taskLabelptions: [],
            selectedTaskLabel: [],
            taskTitle: null,
        }
    },

    watch: {
        '$store.state.isUpdateTaskKanban'(val) {
            if (val) {
                this.getTask();
                this.$store.commit('UPDATE_TASK_KANBAN', false);
            }
        }
    },
    async created() {
        this.projectId = parseInt(this.$route.query.id, 10);
        let branchList = JSON.parse(localStorage.getItem('branchInfoList') || '[]');
        if (branchList.length === 0) {
            return this.$vs.notify({
                text: this.$t('warningMenuOrganization.emptyEmployee'),
                iconPack: 'feather',
                icon: 'icon-alert-circle',
                color: 'danger'
            });
        }
        this.organizationBranchOptions = branchList.filter(el => el.organizationBranchType !== 3).map(item => {
            return {value: item.id, label: item.organizationBranchName}
        });
        this.organizationBranchOptions.unshift({value: null, label: this.$t('menuOrganization.all')})
        let titleQuery = this.$route.query.title
        this.taskTitle = titleQuery ? titleQuery : null
        if (this.projectId) {
            this.selectedProjectId = this.projectId
            await this.getEmployee()
        } else {
            await this.getAllEmployee()
        }
        await this.getProject()
        await this.getStt()
        await this.getTaskLabel()
        await this.getPriority()
        this.getTask();
    },
    methods: {
        changSelecEmployee() {
            this.collaboratorsOption = this.employeeOptionPopup.filter(el => el.value !== this.taskData.selectedEmployeeOption)
        },
        changeSelectMultiple() {
            this.taskData.collaborators = [];
            this.selectedCollaborators.forEach(el => {
                this.taskData.collaborators.push(el.value);
            })
        },
        changeSelectTaskLabel() {
            this.taskData.labels = [];
            this.selectedTaskLabel.forEach(el => {
                this.taskData.labels.push(el.label);
            })
        },
        async addNewTask() {
            setTimeout(async () => {
                let background = document.getElementById('popup-create-task')
                if (background) {
                    let backgroundUpdate = background.querySelector('.vs-popup--background')
                    if (backgroundUpdate) background.removeChild(backgroundUpdate)
                }
            }, 500)
            this.popupActiveUse = true
            this.taskData = []
            this.selectstartDate = null
            this.selectStartTime = null
            this.selectEndDate = null
            this.selectEndTime = null
            this.selectedCollaborators = []
            this.selecProjecDataPopup = this.projectId ? this.projectId : null
            this.selectedTaskLabel = []
            if (this.projectId) await this.getEmployee()
            this.$validator.reset()
        },

        updateTask(evt, status) {
            if (evt.added) {
                if (this.userInfo.userRole !== "organization") {
                    if ((evt.added.element.assigneeId !== this.userInfo.employeeId) && (evt.added.element.createdByEmployee.employeeId !== this.userInfo.employeeId)) {
                        this.getTask()
                        return this.$vs.notify({
                            text: 'Bạn không có quyền thao tác với nhiệm vụ này!',
                            color: 'danger',
                            iconPack: 'feather',
                            icon: 'icon-alert-circle',
                        });
                    }
                }
                if (evt.added.element.status === 3) {
                    this.getTask()
                    return this.$vs.notify({
                        text: 'Không thể cập nhật nhiệm vụ này!',
                        color: 'danger',
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                    });
                }
                this.dragData = evt.added.element
                this.statusAddId = status

                this.$vs.dialog({
                    type: 'confirm',
                    color: 'warning',
                    title: `Xác nhận cập nhật`,
                    text: `Bạn có chắc là muốn cập nhật task này không ?`,
                    accept: this.acceptChangeStatus,
                    cancel: this.getTask,
                    acceptText: "Cập nhật",
                    cancelText: "Huỷ"

                })
            }
        },
        acceptChangeStatus() {
            let body = {
                title: this.dragData.title,
                description: this.dragData.description,
                // point: this.dragData.point,
                status: this.statusAddId,
                startTime: this.dragData.startTime,
                endTime: this.dragData.endTime,
                assigneeId: this.dragData.assigneeId,
                priority: this.dragData.priority,
                projectId: this.dragData.project.id,
                collaborators: this.dragData.collaborators,
            }
            this.$vs.loading();
            this.$crm.post(`/task/update/${this.dragData.id}`, body).then(() => {
                this.$vs.loading.close();
                this.$vs.notify({
                    color: 'success',
                    text: `Cập nhật thành công`,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                });
                this.getTask()
            }).catch(err => {
                this.$vs.loading.close()
                this.getTask()
                return this.$vs.notify({
                    title: 'Lỗi',
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    color: 'danger',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                });
            })
        },

        getTask() {
            let body = {
                endTime: this.dateRange.endDate,
                organizationBranchId: this.selectedOrganizationBranch,
                startTime: this.dateRange.startDate,
                assigneeId: this.selecEmployee ? this.selecEmployee : null,
                projectId: this.projectId ? this.projectId : JSON.parse(this.selectedProjectId),
                title: this.taskTitle,
                employeeId: this.userInfo.userRole !== 'organization' ? this.userInfo.employeeId : null,
            }
            this.$vs.loading()
            this.$crm.post(`/task/find-by-condition-kanban`, body).then((response) => {
                if (response.data.content && response.data.content.length > 0) {
                    this.kanbanData = response.data.content.map(el => {
                        if (el.taskResponseDTOS.length > 0) {
                            el.taskResponseDTOS.forEach(t => {
                                t.startTimeCvt = t.startTime ? moment(t.startTime).format('DD/MM/YYYY HH:mm') : null;
                                t.endTimeCvt = t.endTime ? moment(t.endTime).format('DD/MM/YYYY HH:mm') : null;
                                if (t.taskChecklists && t.taskChecklists.length > 0) {
                                    t.taskChecklistsTotal = t.taskChecklists.length
                                    t.taskChecklistsDone = t.taskChecklists.filter(x => x.status === 2).length
                                }
                                if (t.labels && t.labels.length > 0) {
                                    t['taskLabel'] = []
                                    t.labels.forEach(x => {
                                        let label = this.taskLabelptions.find(q => q.label === x)
                                        if (label) t.taskLabel.push(label)
                                    })
                                }
                                let listUser = []
                                t.listUser = []
                                if (t.createdByEmployee) listUser.push(t.createdByEmployee)
                                listUser.push(t.assignEmployee)
                                if (t.collaborateEmployees.length > 0) listUser.push(...t.collaborateEmployees)

                                listUser.forEach(el => {
                                    let user = t.listUser.find(x => x.employeeId === el.employeeId)
                                    if (!user) t.listUser.push(el)
                                })
                            })
                        }
                        return el
                    })
                } else {
                    this.kanbanData = []
                }
                this.$vs.loading.close()
            }).catch(err => {
                this.$vs.loading.close()
                return this.$vs.notify({
                    title: 'Lỗi',
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    color: 'danger',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                });
            })
        },

        getStt() {
            return new Promise((resolve, reject) => {
                this.$vs.loading()
                this.$crm.get(`/setting/organization-task-status/find-by-organization-id`).then((response) => {
                    this.$vs.loading.close()
                    if (response.data && response.data.length > 0) {
                        this.statusOptions = response.data.map(el => {
                            return {
                                value: el.status,
                                label: el.title,
                            }
                        })
                    }
                    resolve(response)
                }).catch(err => {
                    reject(err)
                    this.$vs.loading.close();
                    return this.$vs.notify({
                        title: 'Lỗi',
                        text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                        color: 'danger',
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                    });
                })
            })
        },

        getProject() {
            return new Promise((resolve, reject) => {
                let body = {
                    organizationId: this.userInfo.organization.id,
                    employeeId: this.userInfo.userRole !== 'organization' ? this.userInfo.employeeId : null,
                }
                this.$vs.loading()
                this.$crm.post(`/project/find-by-condition`, body).then((response) => {
                    this.$vs.loading.close()
                    if (response.data.content && response.data.content.length > 0) {
                        this.projectData = response.data.content.map(el => {
                            return {
                                value: el.id,
                                label: el.title,
                            }
                        })
                        this.projectData.unshift({value: 'null', label: 'Tất cả'})
                    }
                    if (response.data.content && response.data.content.length > 0) {
                        this.projectDataPopup = response.data.content.map(el => {
                            return {
                                value: el.id,
                                label: el.title,
                            }
                        })
                    }
                    resolve(response)
                    this.$vs.loading.close()
                }).catch(err => {
                    reject(err)
                    this.$vs.loading.close()
                    return this.$vs.notify({
                        title: 'Lỗi',
                        text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                        color: 'danger',
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                    });
                })
            })
        },

        getEmployee() {
            return new Promise(async (resolve, reject) => {
                if (!JSON.parse(this.selectedProjectId) && !this.popupActiveUse) {
                    resolve()
                    await this.getAllEmployee()
                } else {
                    let id = !this.popupActiveUse ? JSON.parse(this.selectedProjectId) : this.selecProjecDataPopup
                    this.$vs.loading()
                    this.$crm.get(`/project/get-project-employees/${id ? id : ''}`).then((response) => {
                        if (response.data && response.data.length > 0) {
                            if (!this.popupActiveUse) {
                                this.selecEmployee = 0
                                this.employeeOption = response.data.map(el => {
                                    return {
                                        value: el.employeeId,
                                        label: el.fullName,
                                    }
                                })
                                this.employeeOption.unshift({value: 0, label: 'Tất cả'})
                            } else {
                                console.log(1234)
                                this.taskData.selectedEmployeeOption = null
                                this.employeeOptionPopup = response.data.map(el => {
                                    return {
                                        value: el.employeeId,
                                        label: el.fullName,
                                    }
                                })
                                console.log(this.employeeOptionPopu)
                            }
                        } else {
                            if (!this.popupActiveUse) {
                                this.employeeOption = [{value: 0, label: 'Tất cả'}]
                            } else {
                                this.employeeOptionPopup = []
                            }
                        }
                        resolve(response)
                        this.$vs.loading.close()
                    }).catch(err => {
                        reject(err)
                        this.$vs.loading.close();
                        return this.$vs.notify({
                            title: 'Thông báo',
                            text: 'Vui lòng chọn project',
                            color: 'danger',
                            iconPack: 'feather',
                            icon: 'icon-alert-circle',
                        })
                    })
                }
            })
        },

        dateRangePicker() {
            this.dateRange.startDate = new Date(this.dateRange.startDate)
            this.dateRange.endDate = new Date(this.dateRange.endDate)
        },

        async saveTask(evt) {
            evt.preventDefault()
            if (!this.validateForm) return
            const result = await this.$validator.validateAll()
            if (!result) return
            const hours = parseInt(this.selectStartTime.split(':')[0])
            const minutes = parseInt(this.selectStartTime.split(':')[1])
            this.selectstartDate = new Date(this.selectstartDate)
            this.selectstartDate.setHours(hours, minutes, 0, 0)
            const hoursEnd = parseInt(this.selectEndTime.split(':')[0])
            const minutesEnd = parseInt(this.selectEndTime.split(':')[1])
            this.selectEndDate = new Date(this.selectEndDate)
            this.selectEndDate.setHours(hoursEnd, minutesEnd, 59, 999)
            if (new Date(this.selectstartDate).getTime() >= new Date(this.selectEndDate).getTime()) {
                return this.$vs.notify({
                    title: 'Lỗi',
                    text: 'Ngày bắt đầu phải nhỏ hơn ngày kết thúc!',
                    color: 'danger',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                })
            }
            let formData = new FormData()
            const dtoData = {
                title: this.taskData.title,
                description: this.taskData.description,
                // point: this.taskData.selectedPoint,
                status: this.taskData.selectedStatus,
                startTime: this.selectstartDate.toISOString(),
                endTime: this.selectEndDate.toISOString(),
                assigneeId: this.taskData.selectedEmployeeOption,
                priority: this.taskData.selectedPriority,
                projectId: this.selecProjecDataPopup,
                collaborators: this.taskData.collaborators,
                labels: this.taskData.labels
            }
            const blob = new Blob([JSON.stringify(dtoData)], {type: 'application/json'})
            formData.append("dto", blob)
            this.$vs.loading()
            this.$crm.post(`/task/create`, formData).then(() => {
                this.$vs.loading.close()
                this.$vs.notify({
                    color: 'success',
                    text: `${this.isUpdate ? 'Cập nhật' : 'Tạo mới'} thành công`,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                })
                this.popupActiveUse = false
                this.getTask()
            }).catch(err => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    title: 'Lỗi',
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    color: 'danger',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                })
            })
        },

        getAllEmployee() {
            return new Promise((resolve, reject) => {
                let userInfo = JSON.parse(localStorage.getItem('userInfo'))
                let payload = {
                    permissions: ['PRIVILEGE_TASK_MODERATOR'],
                    organizationId: userInfo.organization.id
                }
                this.$vs.loading()
                this.$crm.post(`/employee/get-employees-by-permissions`, payload).then((response) => {
                    if (response.data && response.data.length > 0) {
                        this.employeeOption = response.data.map(el => {
                            return {
                                value: el.employeeId,
                                label: el.fullName,
                            }
                        })
                    }
                    resolve(response)
                    this.$vs.loading.close()
                }).catch(err => {
                    reject(err)
                    this.$vs.loading.close()
                    return this.$vs.notify({
                        title: "Lỗi",
                        text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                        color: "danger",
                        iconPack: "feather",
                        icon: "icon-alert-circle",
                    });
                });
            })
        },

        getTaskLabel() {
            return new Promise((resolve, reject) => {
                this.$vs.loading()

                this.$crm.get('/setting/organization-task-label/find-by-organization-id').then(res => {
                    this.$vs.loading.close()
                    this.taskLabelptions = res.data
                    resolve(res)
                }).catch(err => {
                    reject(err)
                    this.$vs.loading.close()
                    return this.$vs.notify({
                        title: "Lỗi",
                        text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                        color: "danger",
                        iconPack: "feather",
                        icon: "icon-alert-circle",
                    });
                });
            })
        },

        getPriority() {
            return new Promise((resolve, reject) => {
                this.$vs.loading()

                this.$crm.get('/setting/organization-task-priority/find-by-organization-id').then(res => {
                    this.$vs.loading.close()
                    this.priorityOptions = res.data.map(el => {
                        el.label = el.title
                        el.value = el.priority
                        return el
                    })
                    resolve(res)
                }).catch(err => {
                    reject(err)
                    this.$vs.loading.close()
                    return this.$vs.notify({
                        title: "Lỗi",
                        text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                        color: "danger",
                        iconPack: "feather",
                        icon: "icon-alert-circle",
                    });
                });
            })
        },
    },

    computed: {
        validateForm() {
            return !this.errors.any()
        },

        isPermission() {
            return isAPI(this, constAPI.task_manager)
        },
    }
};
</script>

<style scoped>
.required::after {
    content: '*';
    color: red;
}
</style>

<style lang="scss">
.scroll-area-task {
    max-height: 600px;

    .size-draggable {
        height: 500px;
    }
}

.icon-function {
    color: var(--Light-text-secondary, #89898A);

    font-size: 16px;
    font-weight: 500;
    cursor: pointer;
    margin-right: 20px;

}

.text {
    padding-left: 2px;
    color: inherit;
    font-size: 1rem !important;
}

@media only screen and (max-width: 768px) {
    .button-search {
        margin-bottom: 10px !important;
    }
}

@media only screen and (min-width: 1825px) {
    #screen-size {
        width: 310px !important;
    }
    #title-size {
        width: 310px !important;
    }
}

@media screen and (min-width: 1500px) and (max-width: 1824px) {
    #screen-size {
        width: 250px !important;
    }
    #title-size {
        width: 250px !important;
    }
}

@media screen and (max-width: 1499px) {
    #screen-size {
        width: 240px !important;
    }
    #title-size {
        width: 240px !important;
    }
}

.header-column {
    background-color: white;
    padding: 10px;
    border-radius: 0.25rem 0.25rem 0 0;
}

.task--drag {
    width: 240px;
    //height: 209px;
    border-radius: 0.5rem;
    border: 1px dashed var(--Light-gray-card-border, #BDBDBD) !important;
}

.area-task-kanban {
    background-color: #D9DEE2;
    width: 100%;
    border-radius: 0.5rem;

    .kanban-view {
        width: 100%;
        overflow-x: auto;
    }

    @media only screen and (min-width: 1430px) {
        .kanban-view-more {
            justify-content: center;
        }
    }

    @media screen and (min-width: 1170px) and (max-width: 1200px) {
        .kanban-view-more {
            justify-content: center;
        }
    }

}

#popup-create-task {
    background: rgba(0, 0, 0, .4);
}

</style>
